module.exports = __webpack_public_path__ + "img/noun_edit_258785asdasd.69e6a014.svg";